// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxB3z850hrUbnlhKyzFhzM83RpBf62ns0",
  authDomain: "app-hunt-373e7.firebaseapp.com",
  databaseURL: "https://app-hunt-373e7.firebaseio.com",
  projectId: "app-hunt-373e7",
  storageBucket: "app-hunt-373e7.appspot.com",
  messagingSenderId: "674018567037",
  appId: "1:674018567037:web:bf1b3beaf4497e676aa214",
  measurementId: "G-Y6FT96ENDL",
};

export default firebaseConfig;
